import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

declare global {
  interface Window {
    _env_?: {
      FARO_URL?: string
      FARO_API_KEY?: string
      APP_ENVIRONMENT?: string
    }
  }
}

// Initialize Grafana Faro for browser RUM. No-op when FARO_URL is unset
// (e.g., local dev), so this is safe to call unconditionally.
//
// Captures: JS exceptions, Web Vitals, console warn/error, fetch/XHR
// traces. Trace context is propagated to *.gravitate.energy backends
// via the W3C traceparent header so frontend → backend traces stitch
// together in Tempo.
//
// Called from src/index.tsx before <App /> mounts so page-load metrics
// (LCP, INP, CLS, TTFB, FCP) are captured.
export function initFaro(): void {
  const url = window._env_?.FARO_URL
  if (!url) return

  initializeFaro({
    url,
    apiKey: window._env_?.FARO_API_KEY,
    app: {
      name: 'bb-frontend',
      version: import.meta.env.VITE_COMMIT_HASH || '0.0.0',
      environment: window._env_?.APP_ENVIRONMENT || 'local',
    },
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true,
      }),
      new TracingInstrumentation({
        instrumentationOptions: {
          propagateTraceHeaderCorsUrls: [/https:\/\/.*\.gravitate\.energy\/.*/],
        },
      }),
    ],
  })
}
